import {
    LOAD_MONTHLY_BOOKINGS,
    LOAD_WEEKLY_BOOKINGS,
    RESET_CALENDAR_BOOKINGS,
    LOADING_CALENDAR,
} from '../actions/Calendar';

const reducer = (state = { events: [], loading: false }, action) => {
    switch (action.type) {
        case LOADING_CALENDAR:
            return {
                ...state,
                loading: action.payload,
            };
        case RESET_CALENDAR_BOOKINGS:
            return {
                ...state,
                events: action.payload,
            };
        case LOAD_MONTHLY_BOOKINGS:
            return {
                ...state,
                events: action.payload,
            };
        case LOAD_WEEKLY_BOOKINGS:
            return {
                ...state,
                events: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
